import React from "react";
// React Table
import { Container, Row, Col } from "react-bootstrap";

const VistaActividades = ({ datosActividades, objActividades }) => {
  return (
    <Container>
      <Row>
        <Col>
          {datosActividades?.length ? (
            <Container>
              <lu>
                {datosActividades.map((actividad) => (
                  <li key={actividad}>{objActividades[actividad.type]}</li>
                ))}
              </lu>
            </Container>
          ) : (
            <p>Esta misión no tiene asignada actividades actualmente.</p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default VistaActividades;
